import {Component, ElementRef, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {AlertService} from "../../services/alert/alert.service";
import {AlertController, ModalController} from "@ionic/angular";
import {Child} from "../../types/interfaces";
import {codeSharp} from "ionicons/icons";
import {Platform} from '@ionic/angular';
import {PreloaderService} from "../../services/preloader/preloader.service";
import {MyGreenCountry} from "../../services/mygreencountry/my-greencountry";
import {stagger} from "@angular/animations";
import {AuthService} from "../../services/mygreencountry/auth.service";
import {AuthApiResponse} from "../../types/apiResponse.interface";
import {ParentService} from "../../services/mygreencountry/parent.service";
import {EnglishLevelsComponent} from "../../shared/components/modals/english-levels/english-levels.component";
import {PersistenceService} from "../../services/mygreencountry/persistence.service";
import {AnalyticsService} from "../../services/mygreencountry/analytics.service";
import {LANGUAGES} from "../../shared/constants";
import {TranslocoService} from "@jsverse/transloco";
import {LocaleService} from "../../services/mygreencountry/locale.service";
import {IntlTelInputComponent} from "intl-tel-input-ng";
import {PhoneUtilsService} from "../../services/phone-utils/phone-utils.service";


@Component({
    selector: 'app-login',
    templateUrl: './login.page.html',
    styleUrls: ['./login.page.scss'],

    encapsulation: ViewEncapsulation.None,
})
export class LoginPage implements OnInit {

    activeLanguage : string = 'uk';

    @ViewChild('telInputBlock') telInputBlock: ElementRef<HTMLInputElement>;
    @ViewChild('telInputElement') telInputElement!: IntlTelInputComponent;

    public phone: string = '';
    private videoCode: any = '';
    public role: string = '';
    public createNewStudent: boolean = false;
    public authorized = false;
    public checkCabinetInfo: boolean = false;
    public showMoreInfoCabinet: boolean = false;
    hideChildCard: boolean = false;
    showChildrenDropdown: boolean = false;
    isEnterNumberIsDeleted: boolean = false;
    goRegister: boolean = false;
    public showErrors = false;
    protected readonly window = window;
    public authType: string = '';
    public dashboard: string = '';
    public hideStoreLinks: boolean = false;
    public utmData: string[] = [];

    children: Child[] = [];

    constructor(
        public router: Router,
        public alertCtrl: AlertController,
        public alertService: AlertService,
        private platform: Platform,
        private preloaderService: PreloaderService,
        public myGcService: MyGreenCountry,
        private authService: AuthService,
        private parentService: ParentService,
        private modalCtrl: ModalController,
        private route: ActivatedRoute,
        private persistenceService: PersistenceService,
        private analyticService: AnalyticsService,
        private localeService: LocaleService,
        private phoneUtils: PhoneUtilsService
    ) {
        this.telInputBlock = {} as ElementRef<HTMLInputElement>;
        this.activeLanguage = this.localeService.getLanguage();
    }

    ngAfterViewInit() {

        this.hideStoreLinks = this.platform.is('hybrid');

        // setTimeout(() => {
        //
        //     (this.telInputBlock.nativeElement.querySelector('[name=phone]') as HTMLInputElement).type = 'tel';
        //
        // }, 550);

        let checkElement = () => {
            if (this.telInputBlock?.nativeElement) {
                (this.telInputBlock.nativeElement.querySelector('[name=phone]') as HTMLInputElement).type = 'tel';
            } else {
                setTimeout(checkElement, 550);
            }
        };

        setTimeout(checkElement, 550);

    }


    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            const { authorized, freshman } = params;

            if (authorized && this.authService.userIsLogged()) {
                this.authorized = authorized;
                this.children = this.persistenceService.getChildren();
                this.phone = this.persistenceService.get('parentPhone') as string;
                this.authType = this.authService.getType() as string;
            }

            if (freshman) {
                this.createNewStudent = true;
            }

            let utmData = Object.keys(params)
                .map(key => ({ key, value: params[key] }))
                .filter(item => item.key.startsWith('utm_'));

            this.utmData = utmData.map(item => `${item.key}=${encodeURIComponent(item.value)}`);
        });
    }


    ionViewWillLeave() {
        this.resetParameters();
    }


    goToRegister() {

        this.validatePhone(
            (errorResponse) => {
                this.router.navigate(['/registration'], {queryParams: {phone: this.phone, utmData: this.utmData}});

            }
        );
    }


    async doLogin() {
        let phone = this.phone;
        let intlInputInstance = this.telInputElement.intlTelInput;

        if (intlInputInstance) {
            let inputNumber = this.phoneUtils.addCustomPhoneCode(intlInputInstance, phone);

            console.log(inputNumber)

            if (inputNumber) {
                phone = inputNumber;
                this.phone = inputNumber;
            }
        }

        if (phone == undefined) {

            await this.alertService.presentAlert(
                'Enter the phone number in international format. For example, for Ukraine +380 XX XXX XX XX.',
                '',
                [{text: 'ok',}]);

        } else {
            phone = phone.replace(/[^0-9]+/i, '');
            if (!phone.match(/[0-9]{9,15}/i)) {

                // @ts-ignore
                await this.alert(
                    '',
                    'Enter the phone number in international format. For example, for Ukraine +380 XX XXX XX XX.',
                    [{
                        text: 'ok',
                        handler: (data: any) => {

                            this.phone = '' + phone;

                            (this.telInputBlock.nativeElement.querySelector('[name=phone]') as HTMLInputElement).focus();

                        }
                    }]);

            } else {

                this.validatePhone();

            }

        }

    }

    async validatePhone(errorCallback?: (errorResponse: any) => void) {
        await this.preloaderService.showLoading("Зачекайте, будь ласка ");
        this.isEnterNumberIsDeleted = false;

        this.authService
            .validate(this.phone)
            .subscribe({

                next: (data: AuthApiResponse) => {

                    if (data.success) {

                        this.children = data.students;

                        this.authService.setType(data.authType);
                        this.authType = data.authType;

                        this.dashboard = data.dashboard;
                        this.parentService.setChildren(this.children);

                        if ( this.dashboard == 'student') {

                            this.goToChildDashboard(this.children[0])

                            // this.proceedLogin(this.children[0].phone, 'student')

                        } else {

                            // this.parentService.setChildren(this.children);
                            this.authorized = true;

                        }
                    } else {

                        this.isEnterNumberIsDeleted = true;
                    }


                },

                error: (errorResponse: any) => {
                    if (errorCallback) {
                        errorCallback(errorResponse);
                    } else {
                        this.goRegister = true;
                        this.preloaderService.hideLoading();
                    }

                },

                complete: () => {

                    this.preloaderService.hideLoading();

                }

            })

        await this.preloaderService.hideLoading();
    }

    cleanParams() {
        if (this.isEnterNumberIsDeleted || this.goRegister) {
            this.isEnterNumberIsDeleted = false;
            this.goRegister = false;
        }

    }

    async alert(header: string, subHeader: string, buttons: any = []) {

        let alert = await this.alertCtrl.create({
            header: header,
            subHeader: subHeader,
            buttons: buttons
        });
        await alert.present();

    }

    goToChildDashboard(child: Child) {

        this.parentService.setActiveChild(child);

        this.authService.setLoginRole('student');
        this.proceedLogin(child.phone, 'student')

    }

    goToParentDashboard() {

        this.authService.setLoginRole('parent');
        this.proceedLogin(this.phone, 'parent')

    }

    proceedLogin(phone: string, role: string) {

        this.preloaderService.showLoading("Зачекайте, будь ласка");

        this.authService
            .login(phone, role, this.authType)
            .subscribe({
                next: () => {
                    if(!this.platform.is('hybrid')){
                        this.analyticService.login();
                    }

                    this.router.navigate(['/home']);

                },
                error: (errorResponse: any) => {

                    console.log(errorResponse)

                },
                complete: () => {

                    this.preloaderService.hideLoading();

                }
            })

    }


    resetParameters() {
        this.phone = '';
        this.role = 'parent';
        this.createNewStudent = false;
        this.authorized = false;
        this.checkCabinetInfo = false;
        this.showMoreInfoCabinet = false;
        this.hideChildCard = false;
        this.showChildrenDropdown = false;
        this.showErrors = false;
        this.children = [];
    }

    async openModal() {
        const modal = await this.modalCtrl.create({
            component: EnglishLevelsComponent,
            cssClass: 'auto-height',
            componentProps: {
                isCabinetInfo: true,
            }
        });

        await modal.present();

        const {data, role} = await modal.onWillDismiss();
    }

    refresh(){
        this.router.navigate(['/login'], { replaceUrl: true }).then(() => {

            window.location.reload();
        });
    }
}
